var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/exclamation_circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-480, -391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-3",
    transform: "translate(48, 391)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Exclamation-Circle",
    transform: "translate(432, 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,12 C22,17.5240726 17.5224597,22 12,22 C6.47754032,22 2,17.5240726 2,12 C2,6.47915323 6.47754032,2 12,2 C17.5224597,2 22,6.47915323 22,12 Z M12,14.016129 C10.9756048,14.016129 10.1451613,14.8465726 10.1451613,15.8709677 C10.1451613,16.8953629 10.9756048,17.7258065 12,17.7258065 C13.0243952,17.7258065 13.8548387,16.8953629 13.8548387,15.8709677 C13.8548387,14.8465726 13.0243952,14.016129 12,14.016129 Z M10.2389919,7.34895161 L10.5381048,12.8328226 C10.5520968,13.0894355 10.7642742,13.2903226 11.02125,13.2903226 L12.97875,13.2903226 C13.2357258,13.2903226 13.4479032,13.0894355 13.4618952,12.8328226 L13.7610081,7.34895161 C13.776129,7.07177419 13.5554435,6.83870968 13.2778629,6.83870968 L10.7220968,6.83870968 C10.4445161,6.83870968 10.223871,7.07177419 10.2389919,7.34895161 L10.2389919,7.34895161 Z",
    id: "Icon",
    fill: "#FFE88E"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamationCircle);
export default __webpack_public_path__ + "static/media/icon-exclamation_circle.2ecc4389.svg";
export { ForwardRef as ReactComponent };